// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/PlatformWebhooks_TestSendResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** POST /platform-webhooks/test-send — success at the envelope; the delivery OUTCOME is in `delivery.status`. */
import type { PlatformWebhooks_DeliveryRow } from './PlatformWebhooks_DeliveryRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface PlatformWebhooks_TestSendResponseDados {
delivered: boolean
event_id: number
delivery: PlatformWebhooks_DeliveryRow
}

export type PlatformWebhooks_TestSendResponse = ApiResponse<PlatformWebhooks_TestSendResponseDados>;

registerResponseContract('PlatformWebhooks_TestSendResponse', {
  delivered: { type: 'boolean', required: true },
  event_id:  { type: 'number',  required: true },
  delivery: {
    type: 'object',
    required: false,
    fields: {
      id:              { type: 'number',  required: true },
      delivery_uuid:   { type: 'string',  required: false },
      event:           { type: 'string',  required: false },
      franquia_id:     { type: 'number',  required: false },
      is_test:         { type: 'boolean', required: false },
      plugin:          { type: 'string',  required: false },
      url:             { type: 'string',  required: false },
      status:          { type: 'string',  required: false },
      attempts:        { type: 'number',  required: false },
      response_code:   { type: 'number',  required: false },
      response_body:   { type: 'string',  required: false },
      next_attempt_at: { type: 'string',  required: false },
      delivered_at:    { type: 'string',  required: false },
      created_at:      { type: 'string',  required: false },
    },
  },
})
